<template>
  <session class="page-aboutus">
    <TopNavs :list="navs" :target="curNav" @click="(target) => tabNav(target)" />

    <div class="page-aboutus-i js-page-aboutus">
      <div ref="bannerRef">
        <Banner :title="bannerTitle" :content="bannerContent" :cover="IMG_BANNER_COVER" />
      </div>
      
      <div class="aboutus-block" ref="block1Ref">
        <div class="block-header">
          <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Title }}</span>
          <span class="desc" v-html="Utils.presetHtmlText(block1Desc)" />
        </div>
        <div class="block1-body">
          <div class="block-body-nav">
            <div class="item" :class="{ active: item?.name == block1ListCurItem?.name }" v-for="(item, index) in block1List" :key="index" @click="block1ListTab(index)" @mouseenter="block1ListTab(index)">
              <div class="icon-wrap"><Icon size="48" name="checkmore" /></div>
              <span :class="{ ffen: getLocalLangCode() != 'zh', en: getLocalLangCode() == 'en' }">{{item.name}}</span>
            </div>
          </div>
          <div class="block-body-content-wrap">
            <div class="block-body-content" :class="{ active: item?.name == block1ListCurItem?.name }" v-for="(item, index) in block1List" :key="index">
              <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.title}}</span>
              <span class="desc">{{item?.desc}}</span>
              <div class="img-wrap">
                <div class="img" :style="{ backgroundImage: `url(${item?.cover})` }" />
                <div class="icon-wrap"><Icon name="quotation2" size="54" sizeh="30" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="aboutus-block" ref="block2Ref">
        <div class="block-header">
          <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block2Title }}</span>
          <span class="desc" v-html="Utils.presetHtmlText(block2Desc)" />
        </div>
        <div class="block2-body">
          <div class="block-body-nav">
            <div class="item" :class="{ active: item?.name == block2ListCurItem?.name }" v-for="(item, index) in block2List" :key="index" @click="block2ListTab(index)" @mouseenter="block2ListTab(index)">
              <div class="line" />
              <div class="content">
                <span class="name" :class="{ ffen: getLocalLangCode() != 'zh' }">{{item.name}}</span>
                <span class="position">{{item.position}}</span>
              </div>
            </div>
          </div>
          <div class="block-body-content-wrap">
            <div class="checkmorewrap"><Icon name="checkmore" size="48" /></div>
            <div class="block-body-content" :class="{ active: item?.name == block2ListCurItem?.name }" v-for="(item, index) in block2List" :key="index">
              <div class="block-body-content-t">
                <div class="block-body-content-tl">
                  <span class="name" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.enName }}</span>
                  <span class="name" :class="{ ffen: getLocalLangCode() != 'zh' }" v-if="item?.enName != item?.name">{{ item?.name }}</span>
                  <span class="position">{{ item?.position }}</span>
                </div>
                <div class="block-body-content-tr"><img :src="item?.cover" /></div>
              </div>
              <div class="block-body-content-b">
                <span v-html="Utils.presetHtmlText(item?.intro)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="aboutus-block" ref="block3Ref">
        <div class="flight-wrap">
          <div class="flight" :class="{ show: !!show }"><Icon name="flight" size="109" /></div>
          <div class="line" :class="{ show: !!show }" />
        </div>
        <div class="block-header">
          <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block3Title }}</span>
        </div>
        <div class="block3-body">
          <div class="block-body-content">
            <div class="block-body-content-t">
              <div class="item item1" :class="{ show: !!show }"><div class="img" :style="{ backgroundImage: `url(${IMG_CORPORATE_COVER_t1})` }" /></div>
              <div class="item item2" :class="{ show: !!show }">
                <div class="txt">
                  <span v-html="Utils.presetHtmlText(block3Desc)" />
                </div>
                <div class="txt-space">
                  <span v-html="Utils.presetHtmlText(block3Desc)" />
                </div>
                <!-- <span v-html="Utils.presetHtmlText(block3Desc)" /> -->
                <div class="img" :style="{ backgroundImage: `url(${IMG_CORPORATE_COVER_t2})` }" />
              </div>
              <div class="item item3" :class="{ show: !!show }"><div class="img" :style="{ backgroundImage: `url(${IMG_CORPORATE_COVER_t3})` }" /></div>
            </div>
          </div>
        </div>
      </div>

      <div class="aboutus-block" style="margin-top: 0;">
        <div class="block3-body" style="border-top: 0;">
          <div class="block-body-content">
            <div class="block-body-content-b">
              <div class="item" v-for="(item, index) in block3List" :key="index">
                <div class="order"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.order}}</span></div>
                <div class="item-content">
                  <div class="item-content-l">
                    <div class="title"><Icon :name="item.icon" size="40" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</span></div>
                    <div class="desc">{{ item?.desc }}</div>
                  </div>
                  <div class="item-content-r">
                    <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="joinus" ref="joinusRef">
        <div class="txt"><span :class="{ ffen: getLocalLangCode() != 'zh' }" v-html="Utils.presetHtmlText(joinusTitle)" /></div>
        <div class="intro">
          <div class="item"><span v-html="Utils.presetHtmlText(joinusContent1)" /></div>
          <div class="item"><span v-html="Utils.presetHtmlText(joinusContent2)" /></div>
        </div>
      </div>

      <Footer />
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
  import Banner from '@/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/components/footer/index.vue';
  import EventBus from '@/assets/eventbus';

  // imgs
  import IMG_BANNER_COVER from './images/cover.png';
  
  import IMG_MISSION_COVER_1 from './images/mission_cover_1.png';
  import IMG_MISSION_COVER_2 from './images/mission_cover_2.png';
  import IMG_MISSION_COVER_3 from './images/mission_cover_3.png';
  import IMG_MISSION_COVER_4 from './images/mission_cover_4.png';

  import IMG_LEADERSHIP_COVER_1 from './images/leadership_cover_1.png';
  import IMG_LEADERSHIP_COVER_2 from './images/leadership_cover_2.png';
  import IMG_LEADERSHIP_COVER_3 from './images/leadership_cover_3.png';
  import IMG_LEADERSHIP_COVER_4 from './images/leadership_cover_4.png';
  import IMG_LEADERSHIP_COVER_5 from './images/leadership_cover_5.png';
  
  import IMG_CORPORATE_COVER_t1 from './images/corporate_cover_t1.png';
  import IMG_CORPORATE_COVER_t2 from './images/corporate_cover_t2.png';
  import IMG_CORPORATE_COVER_t3 from './images/corporate_cover_t3.png';
  import IMG_CORPORATE_COVER_1 from './images/corporate_cover_1.png';
  import IMG_CORPORATE_COVER_2 from './images/corporate_cover_2.png';
  import IMG_CORPORATE_COVER_3 from './images/corporate_cover_3.png';

  /**
   * navs
   */
  // nav list
  const navs = ref([
    { id: 1, label: LOCAL('aboutus_aboutUs') },
    { id: 2, label: LOCAL('aboutus_mission') },
    { id: 3, label: LOCAL('aboutus_leadership') },
    { id: 4, label: LOCAL('aboutus_corporate') },
    { id: 5, label: LOCAL('aboutus_joinus') },
  ]);
  // nav target
  const bannerRef = ref(null);
  const block1Ref = ref(null);
  const block2Ref = ref(null);
  const block3Ref = ref(null);
  const joinusRef = ref(null);
  // cur nav
  const curNav = ref(null)
  const tabNav = (target, isJump) => {
    // console.log('target', target, "isJump", isJump)
    if(isJump) {
      curNav.value = target;
      return;
    }

    // 滚动到……
    if(target?.id == 1 && bannerRef.value) {
      bannerRef.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
    if(target?.id == 2 && block1Ref.value) {
      block1Ref.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
    if(target?.id == 3 && block2Ref.value) {
      block2Ref.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
    if(target?.id == 4 && block3Ref.value) {
      block3Ref.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
    if(target?.id == 5 && joinusRef.value) {
      joinusRef.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
  }
  onMounted(() => {
    tabNav(navs.value[0], true)
  })
  const scrollHandle = () => {
    const el = document.querySelector('.js-page-aboutus');
    el.addEventListener('scroll', e => {
      const isToBottom = e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight;
      const curpoi = e.target.scrollTop + 84 + 78;
      if(curpoi > joinusRef.value.offsetTop || isToBottom) {
        tabNav(navs.value[4], true);
      }else if(curpoi > block3Ref.value.offsetTop){
        tabNav(navs.value[3], true);
      }else if(curpoi > block2Ref.value.offsetTop){
        tabNav(navs.value[2], true);
      }else if(curpoi > block1Ref.value.offsetTop){
        tabNav(navs.value[1], true);
      }else if(curpoi > bannerRef.value.offsetTop){
        tabNav(navs.value[0], true);
      }
    });
  }
  onMounted(() => {
    scrollHandle()
  })

  // banner
  const bannerTitle = ref('')
  const bannerContent = ref('')
  const bannerInit = () => {
    bannerTitle.value = LOCAL('aboutus_aboutUs');
    bannerContent.value = LOCAL('aboutus_aboutUs_desc');
  }
  onMounted(() => {
    bannerInit()
  })

  // 宗旨和价值观
  const block1Title = ref('');
  const block1Desc = ref('');
  const block1List = ref('');
  const block1ListCurItem = ref(null)
  const block1ListTab = (index = 0) => {
    block1ListCurItem.value = block1List.value[index];
  }
  const block1Init = () => {
    block1Title.value = LOCAL('aboutus_mission');
    block1Desc.value = LOCAL('aboutus_mission_desc');
    block1List.value = [
      { name: LOCAL('aboutus_mission_1_title'), title: LOCAL('aboutus_mission_1_desc1'), desc: LOCAL('aboutus_mission_1_desc2'), cover: IMG_MISSION_COVER_1 },
      { name: LOCAL('aboutus_mission_2_title'), title: LOCAL('aboutus_mission_2_desc1'), desc: LOCAL('aboutus_mission_2_desc2'), cover: IMG_MISSION_COVER_2 },
      { name: LOCAL('aboutus_mission_3_title'), title: LOCAL('aboutus_mission_3_desc1'), desc: LOCAL('aboutus_mission_3_desc2'), cover: IMG_MISSION_COVER_3 },
      { name: LOCAL('aboutus_mission_4_title'), title: LOCAL('aboutus_mission_4_desc1'), desc: LOCAL('aboutus_mission_4_desc2'), cover: IMG_MISSION_COVER_4 },
    ];
  }
  onMounted(() => {
    block1Init()
    block1ListTab()
  });

  // 管理层简介
  const block2Title = ref('');
  const block2Desc = ref('');
  const block2List = ref('');
  const block2ListCurItem = ref(null);
  const block2ListTab = (index = 0) => {
    block2ListCurItem.value = block2List.value[index];
  }
  const block2Init = () => {
    block2Title.value = LOCAL('aboutus_leadership');
    block2Desc.value = LOCAL('aboutus_leadership_desc');
    block2List.value = [
      { name: LOCAL('aboutus_leadership_1_name')[1], enName: LOCAL('aboutus_leadership_1_name')[0], position: LOCAL('aboutus_leadership_1_poi'), intro: LOCAL('aboutus_leadership_1_desc'), cover: IMG_LEADERSHIP_COVER_1 },
      { name: LOCAL('aboutus_leadership_2_name')[1], enName: LOCAL('aboutus_leadership_2_name')[0], position: LOCAL('aboutus_leadership_2_poi'), intro: LOCAL('aboutus_leadership_2_desc'), cover: IMG_LEADERSHIP_COVER_2 },
      { name: LOCAL('aboutus_leadership_3_name')[1], enName: LOCAL('aboutus_leadership_3_name')[0], position: LOCAL('aboutus_leadership_3_poi'), intro: LOCAL('aboutus_leadership_3_desc'), cover: IMG_LEADERSHIP_COVER_3 },
      { name: LOCAL('aboutus_leadership_4_name')[1], enName: LOCAL('aboutus_leadership_4_name')[0], position: LOCAL('aboutus_leadership_4_poi'), intro: LOCAL('aboutus_leadership_4_desc'), cover: IMG_LEADERSHIP_COVER_4 },
      { name: LOCAL('aboutus_leadership_5_name')[1], enName: LOCAL('aboutus_leadership_5_name')[0], position: LOCAL('aboutus_leadership_5_poi'), intro: LOCAL('aboutus_leadership_5_desc'), cover: IMG_LEADERSHIP_COVER_5 },
    ];
  }
  onMounted(() => {
    block2Init()
    block2ListTab()
  });

  // 社会责任
  const block3Title = ref('');
  const block3Desc = ref('');
  const block3List = ref([]);
  const block3Init = () => {
    block3Title.value = LOCAL('aboutus_corporate');
    block3Desc.value = LOCAL('aboutus_corporate_desc');
    block3List.value = [
      { order: '01', icon: 'jiankangfupin', title: LOCAL('aboutus_corporate_1_title'), desc: LOCAL('aboutus_corporate_1_desc'), cover: IMG_CORPORATE_COVER_1 },
      { order: '02', icon: 'shequguanhuai', title: LOCAL('aboutus_corporate_2_title'), desc: LOCAL('aboutus_corporate_2_desc'), cover: IMG_CORPORATE_COVER_2 },
      { order: '03', icon: 'huanjingbaohu', title: LOCAL('aboutus_corporate_3_title'), desc: LOCAL('aboutus_corporate_3_desc'), cover: IMG_CORPORATE_COVER_3 },
    ];
  }
  onMounted(() => {
    block3Init()
  });
  const show = ref(false)
  onMounted(() => {
    setTimeout(() => {
      show.value = true
    }, 3000)
  });

  // 加入我们
  const joinusTitle = ref('');
  const joinusContent1 = ref('');
  const joinusContent2 = ref('');
  const joinusInit = () => {
    joinusTitle.value = LOCAL('aboutus_joinus_title');
    console.log('joinusTitle.value', joinusTitle.value)
    joinusContent1.value = LOCAL('aboutus_joinus_intro1');
    joinusContent2.value = LOCAL('aboutus_joinus_intro2');
  }
  onMounted(() => {
    joinusInit()
  });

  // 左侧回到顶部交互
  onMounted(() => {
    Utils.scrollToTop.register('js-page-aboutus');
    EventBus.on('global_page_scroll_action_js-page-aboutus', () => {
      tabNav(navs.value[0]);
    });
  });
</script>

<style scoped lang="less">
  @import "index.less";
</style>
